import React, { Component } from 'react'
import { db } from '../../../config/firebaseconfig'
import { ImageThumbnails, ImageInsertion } from './'
import { Input } from 'reactstrap'

class ImageGallery extends Component {

  state = {
    filter: '',
    images: null,
    loading: false,
    error: '',
  }

  componentDidMount() {
    this.setState({loading: true, error: ''})
    this.unsubscribe = db.collection('images').onSnapshot((snapshot) => {
      const images = []
      snapshot.forEach(image => {
        if (image.exists) images.push(image.data())
      })
      this.setState({loading: false, images, error: ''})
      },
      (error) => this.setState({error, loading: false,})
    )
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  changeFilter = ({target}) => this.setState({filter: target.value})

  render() {
    const { activeImage, selectImage } = this.props
    const { images, filter } = this.state
    const { changeFilter } = this
    const filteredImages = images && images.filter(im => {
      return  (im.name && im.name.toLowerCase().indexOf(filter.toLowerCase()) > -1) ||
              im.id === activeImage
    })
    const activeImageObj = images && images.filter(im => im.id === activeImage)[0]

    return (
      <div>
        <Input 
          type='text'
          placeholder='Filter images by name'
          value={filter}
          onChange={changeFilter}
        />
        <div style={{maxHeight: '800px', overflow: 'auto'}}>
          <ImageThumbnails 
            filteredImages={filteredImages}
            activeImage={activeImage}
            selectImage={selectImage}
          />
        </div>
        <ImageInsertion 
          activeImage={activeImageObj}
        />
      </div>
    )
  }
}

export default ImageGallery


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/ImageGallery.js